module.exports = __webpack_public_path__ + "media/images/rol-6dad0b6fb1c6680f3b8b6e578e04b678.png";